import { z } from 'zod';

export const CustomerDTO = z.object({
    customerId: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    favoriteStoreId: z.string().optional(),
    isSubscribedByEmail: z.boolean().optional(),
    loyalty: z
        .object({
            currentPoints: z.number(),
            pointsToNextDiscount: z.number(),
            status: z.string().optional(),
        })
        .optional(),
    gender: z.string().optional(),
    type: z.string().optional(),
    hasFavoriteAddress: z.boolean().optional(),
    hasFavoriteCreditCard: z.boolean().optional(),
    hasOffers: z.boolean().optional(),
    creationDate: z.string().optional(),
    ordersCount: z.number().optional(),
    highlightedOffer: z
        .object({
            id: z.string().optional(),
            title: z.string().optional(),
            promoCode: z.string().optional(),
        })
        .optional(),
});

export type CustomerDTO = z.infer<typeof CustomerDTO>;
